import { render } from "./PrimaryAnchor.vue?vue&type=template&id=19ef199e&scoped=true"
import script from "./PrimaryAnchor.vue?vue&type=script&lang=js"
export * from "./PrimaryAnchor.vue?vue&type=script&lang=js"

import "./PrimaryAnchor.vue?vue&type=style&index=0&id=19ef199e&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ef199e"]])

export default __exports__